__turbopack_context__.v({
  "content": "page-module__Jw16tG__content",
  "wrapper": "page-module__Jw16tG__wrapper",
});
